import request from "@/utils/http"; //导入的axios 封装实例
 
// 获取文章列表                        √ √ √ √ √ √
export const api_article_list = (params) => {
    return request({
        url: "/cms/api/articleList",
        method: "get",
        params,
    });
};
// 获取文章列表置顶                        √ √ √ √ √ √
export const api_article_list_top = (params) => {
    return request({
        url: "/cms/api/topArticleList",
        method: "get",
        params,
    });
};
// 获取文章详情  (id :string)                                           √ √ √ √ √ √
export const api_article_detail = (params) => {
    return request({
        url: "/cms/api/articleDetail",
        method: "get",
        params,
    });
};
// 轮播图列表  (categoryId :string)
export const api_banner_list = (params) => {
    return request({
        url: "/cms/api/bannerList",
        method: "get",
        params,
    });
};
// 获取栏目列表  (无参数)                                                   √ √ √ √ √ √
export const api_category = (params) => {
    return request({
        url: "/cms/api/category",
        method: "get",
        params,
    });
};
// 获取友链列表  ( )                                                       √ √ √ √ √ √
export const api_friendship_list = (params) => {
    return request({
        url: "/cms/api/friendshipList",
        method: "get",
        params,
    });
};
// 获取公司信息  ( )                                                          √ √ √ √ √ √
export const api_company_info = (params) => {
    return request({
        url: "/cms/api/getCompanyInfo",
        method: "get",
        params,
    });
};
// 获取网站信息  ( )                                                          √ √ √ √ √ √
export const api_site_info = (params) => {
    return request({
        url: "/cms/api/getSiteInfo",
        method: "get",
        params,
    });
};
// 获取合作伙伴列表  ( )                                                   √ √ √ √ √ √
export const api_partners_list = (params) => {
    return request({
        url: "/cms/api/partnersList",
        method: "get",
        params,
    });
};
// 保存留言  ( )                                                           √ √ √ √ √ √
export const api_save_leave = (data) => {
    return request({
        url: "/cms/api/saveLeave",
        method: "post",
        data,
    });
};
// 发展历程  ( )
export const api_time_line = (params) => {
    return request({
        url: "/cms/api/timeline",
        method: "get",
        params,
    });
};